<template>
  <div class="component-container">
    <FormContainer>
      <!-- 表单阶段和对话阶段都在FormContainer内 -->
      <Transition name="fade" mode="out-in">
        <PersonalInfoStep1Content v-if="!showDialog" key="form" @next="handleNext" />
        <div v-else key="dialog" class="dialog-wrapper">
          <Dialog />
        </div>
      </Transition>
    </FormContainer>
  </div>
</template>

<script setup>
import { defineEmits, ref } from 'vue'
import FormContainer from './FormContainer.vue'
import PersonalInfoStep1Content from './PersonalInfoStep1Content.vue'
import Dialog from "@/views/Dialog.vue"

const emit = defineEmits(['next'])

// 控制组件切换的响应式变量
const showDialog = ref(false)
const formData = ref(null)

// 处理下一步：从表单切换到对话框
const handleNext = (stepData) => {
  console.log('表单数据:', stepData)
  console.log('切换到Dialog组件')
  formData.value = stepData
  showDialog.value = true
  
  // 如果父组件需要这个数据，也可以继续向上传递
  emit('next', stepData)
}

// 返回表单（如果需要的话）
const goBackToForm = () => {
  showDialog.value = false
}

// 暴露方法给父组件使用（可选）
defineExpose({
  goBackToForm,
  formData: formData.value
})
</script>

<style scoped>
.component-container {
  width: 100%;
  height: 100%;
  position: relative;
}

/* 淡入淡出过渡动画 */
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease-in-out;
}

.fade-enter-from {
  opacity: 0;
  transform: translateY(20px);
}

.fade-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
  transform: translateY(0);
}

/* Dialog包装器样式 */
.dialog-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
}
/*

!* 为Dialog组件在FormContainer内的适配样式 *!
:deep(.dialog-page) {
  height: 100% !important;
  width: 100% !important;
  position: relative !important;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
*/

/*:deep(.messages-container) {
  flex: 1;
  max-height: 300px !important;
  min-height: 250px !important;
  padding: 10px !important;
  overflow-y: auto;
}*/

:deep(.input-container) {
  position: relative !important;
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;
  margin-top: 10px;
  flex-shrink: 0;
}

:deep(.hero) {
  padding: 10px !important;
  flex-shrink: 0;
}

:deep(.bg-gradient) {
  display: none !important;
}

/* 调整输入栏在FormContainer内的样式 */
:deep(.input-bar) {
  height: 50px !important;
}

:deep(.btn-attach) {
  width: 40px !important;
  height: 50px !important;
}

:deep(.btn-send) {
  width: 40px !important;
  height: 40px !important;
}
</style>
